export default defineAppConfig({
  ui: {
    primary: 'orange',
    gray: 'neutral',
    notifications: {
      // Show toasts at the bottom left of the screen
      position: 'fixed bottom-0 left-1/2 transform -translate-x-1/2',
    },
    tooltip: {
      base: '[@media(pointer:coarse)]:hidden h-auto px-2 py-1 text-xs font-normal whitespace-normal',
    }
  },
})
